import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {ConnectivityIssues} from '@wr/ui-patterns';

import * as optileActions from '../../../actions/optile';
import {
    getTranslations,
    getLanguageCode,
    getAvailableLanguageCodes,
    getGenericError,
    getTracking,
    getCustomer,
    getPlatformData,
    getCalculation
} from '../../../utils/selectors';
import assetUrl from '../../../utils/assetUrl';
import {setPageLoadEvent} from '../../organisms/Analytics/pageLoadEvent';
import {setCalculation} from '../../../actions/common/action-creators';

const loaderImgPath = assetUrl('images/loader.gif');

const OptilePaymentProcessing = ({
    match,
    translations,
    languageCode,
    availableLanguageCodes,
    dispatch,
    genericError,
    tracking,
    customer,
    platformData,
    calculation
}) => {
    const {params: {sessionId}} = match;
    const {paymentProcessing, connectivityIssues} = translations;

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        setPageLoadEvent({
            tracking,
            customer,
            platformData,
            pageName: '/transfer/payment/bank-payment-processing-optile',
            calculation
        });
    }, []);

    useEffect(() => {
        dispatch(optileActions.paymentAutorise(sessionId, languageCode, availableLanguageCodes));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [languageCode, sessionId, dispatch, JSON.stringify(availableLanguageCodes)]);


    return (
        <section className="payment-processing">
            <div className="payment-processing-block">
                {genericError ? (
                    <ConnectivityIssues
                        translations={connectivityIssues}
                        href="/"
                    />
                ) : (
                    <>
                        <img
                            src={loaderImgPath}
                            alt={paymentProcessing.heading}
                        />
                        <h1>{paymentProcessing.heading}</h1>
                        <p className="payment-processing-prompt">{paymentProcessing.paragraphText}</p>
                    </>
                )}
            </div>
        </section>
    );
};

OptilePaymentProcessing.getServerSideProps = async ({
    session
}, store) => {
    store.dispatch(setCalculation(session.calculation));
};

OptilePaymentProcessing.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            sessionId: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired,
    languageCode: PropTypes.string.isRequired,
    availableLanguageCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    genericError: PropTypes.bool,
    calculation: PropTypes.shape()
};

OptilePaymentProcessing.defaultProps = {
    genericError: false,
    calculation: null
};

const mapStateToProps = state => ({
    translations: getTranslations(state),
    languageCode: getLanguageCode(state),
    availableLanguageCodes: getAvailableLanguageCodes(state),
    genericError: getGenericError(state),
    tracking: getTracking(state),
    customer: getCustomer(state),
    platformData: getPlatformData(state),
    calculation: getCalculation(state)
});

export const ConnectedOptilePaymentProcessing = connect(mapStateToProps)(OptilePaymentProcessing);

export default withRouter(ConnectedOptilePaymentProcessing);
